import { render, staticRenderFns } from "./AdquisicionCofi.vue?vue&type=template&id=0d010a5c&scoped=true&lang=html&"
import script from "./AdquisicionCofi.vue?vue&type=script&lang=js&"
export * from "./AdquisicionCofi.vue?vue&type=script&lang=js&"
import style0 from "./AdquisicionCofi.vue?vue&type=style&index=0&id=0d010a5c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d010a5c",
  null
  
)

export default component.exports